import { render, staticRenderFns } from "./CloudComplianceDetailsPopup.vue?vue&type=template&id=38679354&scoped=true"
import script from "./CloudComplianceDetailsPopup.vue?vue&type=script&lang=js"
export * from "./CloudComplianceDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./CloudComplianceDetailsPopup.vue?vue&type=style&index=0&id=38679354&prod&lang=scss"
import style1 from "./CloudComplianceDetailsPopup.vue?vue&type=style&index=1&id=38679354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38679354",
  null
  
)

export default component.exports